var Tool = {};
var class2type = {},
  toString = class2type.toString;

/**
 * 获取变量类型
 * @method type
 * @param {Any} obj 需要查询的变量
 * @return {String} 变量类型
 */
Tool.type = function(obj) {
  return obj == null ? String(obj) : class2type[toString.call(obj)] || 'object';
};
/**
 * 判断变量是否是数组
 * @method isArray
 * @param {Any} value 需要查询的变量
 * @return {Boolean} 是否是数组
 */
Tool.isArray = function(value) {
  return value instanceof Array;
};
/**
 * 判断变量是否是方法
 * @method isFunction
 * @param {Any} value 需要查询的变量
 * @return {Boolean} 是否是方法
 */
Tool.isFunction = function(value) {
  return Tool.type(value) == 'function';
};

function isObject(obj) {
  return typeof obj === 'object';
}
function isWindow(obj) {
  return obj != null && obj == obj.window;
}
/**
 * 判断指定参数是否是一个纯粹的对象(就是该对象是通过"{}"或"new Object"创建的)
 * @method isPlainObject
 * @param {Object} obj 需要查询的变量
 * @return {Boolean} 是否是纯粹的对象
 */
Tool.isPlainObject = function(obj) {
  return (
    isObject(obj) &&
    !isWindow(obj) &&
    Object.getPrototypeOf(obj) == Object.prototype
  );
};

var sessionCache = {
  /**
   * 获取window.name中数据
   *
   * @method getWindow
   * @private
   * @return {Object} window.name转换后的对象
   */
  getWindow: function() {
    try {
      return JSON.parse(window.name || '{}');
    } catch (e) {
      return {};
    }
  },
  /**
   * 设置window.name的数据
   *
   * @method setWindow
   * @private
   * @param {Object} data 需要写入到window.name中的缓存数据
   */
  setWindow: function(data) {
    data && (window.name = JSON.stringify(data));
  },
  /**
   * 根据key获取session级的缓存
   *
   * @method Tool.sessionCache.getItem
   * @param  {String} key 获取的缓存键值名
   * @param  {Boolean} [force:false] 是否强制使用window.name
   */
  getItem: function(key, force) {
    if (Tool.isSessionAble && !force) {
      return Tool.storage.getItem(key, false);
    } else {
      var data = this.getWindow();

      if (Tool.isPlainObject(data)) {
        return data[key];
      }
    }
  },
  /**
   * 设置session级的缓存
   *
   * @method Tool.sessionCache.setItem
   * @param {String} key   存储的键值
   * @param {String} value 存储的值
   * @param {Boolean} merge 是否进行合并
   * @param {Boolean} [force:false] 是否强制使用window.name
   */
  setItem: function(key, value, merge, force) {
    if (
      merge &&
      Tool.isPlainObject(value) &&
      Tool.isPlainObject(this.getItem(key))
    ) {
      value = Object.assign(this.getItem(key), value);
    }

    if (Tool.isSessionAble && !force) {
      Tool.storage.setItem(key, value, false);
    } else {
      var data = this.getWindow();

      if (!Tool.isPlainObject(data)) {
        data = {};
      }
      data[key] = value;

      this.setWindow(data);
    }
  },
  /**
   * 删除指定的session缓存
   *
   * @method Tool.sessionCache.removeItem
   * @param  {String} key 删除的键值
   * @param  {Boolean} [force:false] 是否强制使用window.name
   */
  removeItem: function(key, force) {
    if (Tool.isSessionAble && !force) {
      Tool.storage.removeItem(key, false);
    } else {
      var data = this.getWindow();

      if (Tool.isPlainObject(data)) {
        delete data[key];

        this.setWindow(data);
      }
    }
  }
};

Tool.sessionCache = sessionCache;

/**
 * 本地存储的特性检测
 *
 * @method checkStorage
 * @private
 * @param  {Object} o 检测的存储类型
 * @return {Boolean} 是否支持该种类型的缓存
 */
var checkStorage = function(o) {
  var key = 'STOARGE_TEST',
    value;

  try {
    o.setItem(key, 1);
    value = o.getItem(key);
    o.removeItem(key);

    return value == 1;
  } catch (e) {
    return false;
  }
};

try {
  //兼容IOS7 中禁用cookie的情况：出现localStorage或者sessionStorage就会异常

  /**
   * 判断当前宿主是否支持sessionStorage
   * @property $.isSessionAble
   * @type Boolean
   */
  Tool.isSessionAble = checkStorage(sessionStorage);
  /**
   * 判断当前宿主是否支持localStorage
   * @property $.isLocalAble
   * @type Boolean
   */
  Tool.isLocalAble = checkStorage(localStorage);
} catch (e) {
  Tool.isSessionAble = false;
  Tool.isLocalAble = false;
}

/**
 * 本地存储操作接口
 * <p>
 * localStorage和sessionStorage的统一调用接口，当不支持这两个特性时则不会发生写入操作，也不会出现异常，所以这是一个非安全的存储方式
 * </p>
 * @method storage
 */
var storage = (function() {
  var MAX_TRY = 100; //最大尝试写入次数 如果超过这个次数，依然发生异常则抛出错误提示
  var count = 0;
  var STORAGE_KEY = 'TENPAY_STORAGE_CACHE'; //采用相同的存储键值
  var cacheS = Tool.isSessionAble
    ? JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')
    : {};
  var cacheL = Tool.isLocalAble
    ? JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    : {};

  /**
   * 读取本地存储的数据
   *
   * @method $.storage.setItem
   * @param {String} key 存储的键值
   * @param {String} value 存储的值信息
   * @param {Boolean} [persistence:false] 是否持久化，也就是使用localStorage进行存储
   */
  var _setItem = function(key, value, persistence) {
    count = MAX_TRY; //复位
    if (persistence) {
      cacheL[key] = { v: value, t: +new Date() };
      _flush(persistence);
    } else {
      cacheS[key] = { v: value, t: +new Date() };
      _flush(persistence);
    }
  };

  /**
   * 获取本地存储的值信息
   *
   * @method $.storage.getItem
   * @param {String} key 获取缓存的键值
   * @param {Boolean} [persistence:false] 是否从localStorage中读取数据
   * @return {Object|String} 本地存储指定的键值的数据
   */
  var _getItem = function(key, persistence) {
    var o = persistence ? cacheL[key] : cacheS[key];
    var v = o && o.v;

    return Tool.isPlainObject(v)
      ? Object.assign(true, {}, v)
      : Tool.isArray(v)
        ? Object.assign(true, [], v)
        : v;
  };

  /**
   * 移除本地存储中指定键值的数据
   *
   * @method $.storage.removeItem
   * @param {String} key 移除缓存的键值
   * @param {Boolean} [persistence:false] 是否从localStorage中移除缓存
   */
  var _removeItem = function(key, persistence) {
    count = MAX_TRY; //复位
    persistence ? delete cacheL[key] : delete cacheS[key];
    _flush(persistence);
  };

  /**
   * 将新的缓存信息重新写入到缓存中
   *
   * @method _flush
   * @private
   * @param {Boolean} [persistence:false] 控制写入缓存到sessionStorage还是localStorage
   */
  var _flush = function(persistence) {
    var o;

    try {
      //数据格式不正确转换可能导致发生异常
      o = persistence ? JSON.stringify(cacheL) : JSON.stringify(cacheS);
    } catch (e) {
      throw new Error('JSON数据格式异常：' + e.message);
    }

    try {
      if (persistence) {
        Tool.isLocalAble && localStorage.setItem(STORAGE_KEY, o);
      } else {
        Tool.isSessionAble && sessionStorage.setItem(STORAGE_KEY, o);
      }
    } catch (e) {
      count--; //如果发生写入缓存异常则去除旧的数据后重新尝试写入

      if (count >= 0) {
        _shiftByTime(persistence);
        _flush(persistence);
      } else {
        throw new Error('写入缓存异常：' + e.message);
      }
    }
  };

  /**
   * 根据时间排除旧的数据
   *
   * @method _shiftByTime
   * @private
   * @param {Boolean} [persistence:false] 根据写入的时间淘汰旧的值
   */
  var _shiftByTime = function(persistence) {
    var tar = persistence ? cacheL : cacheS;
    var old;

    tar.forEach(function(k, v) {
      if (old) {
        old = old.t > v.t ? v : old;
      } else {
        old = v;
      }
    });

    old && delete tar[old.id];
  };

  return {
    setItem: _setItem,
    getItem: _getItem,
    removeItem: _removeItem
  };
})();

export default storage;
